// !
// ?
// TODO: this is an interesting idea...but is NOT currently working properly
// ?
// !

import { postJSON } from 'utils/http';
import React, {
  createContext,
  useContext,
  useState,
  // useEffect
} from 'react';

const ApiContext = createContext();

const CACHED_APIS = {};

function ApiProvider ({ children }) {
  // whatever you set here as default, will be used in both server side and client as well
  const [providerData, setProviderData] = useState({
    entries: {}
  });

  // you can get extra data asynchronously if needed
  // this will only affect the client side
  // function fetchProviderData () {
  //   setProviderData({
  //     ...providerData,
  //     ready: true,
  //   });
  // }

  // useEffect(() => {
  //   fetchProviderData();
  // }, []);

  const value = {
    ...providerData,
    getScope (path, options = {}) {
      path = path.replace(/\./g, '');
      if (providerData.entries[path]) {
        return providerData.entries[path];
      }

      const newScope = {
        loading: !!options.autoLoad,
        expiresIn: options.expires || null,
        data: {},
        create () {},
        read (filters = {}) {

          // TODO: if loading, return the same
          // TODO: if data, check cache

          // if (providerData.entries[path]?.data) {
          //   return providerData.entries[path];
          // }

          const cacheKey = path + JSON.stringify(filters);

          if (CACHED_APIS[cacheKey]) {
            return {
              data: CACHED_APIS[cacheKey],
              error: null
            };
          }

          let action = Object.keys(filters).length ? 'find' : 'list';
          if (path.includes('/')) {
            action = path; // the action was provided
          }

          return postJSON(`api/${path}/${action}`, filters)
            .then(({data, error}) => {
              if (error) {
                throw new Error(error);
              }

              setProviderData(currentData => {
                const newData = {...currentData};
                newData.entries[path].data = data;
                newData.entries[path].loading = false;
                return newData;
              });

              CACHED_APIS[cacheKey] = data;

              if (options.expires) {
                setTimeout(_ => {
                  setProviderData(currentData => {
                    const newData = {...currentData};
                    delete newData.entries[path];
                    return newData;
                  });
                  delete CACHED_APIS[cacheKey];
                }, options.expires * 1000);
              }

              return { data, error };
            })
            .catch(error => {
              if (error) {
                console.error('API Provider error :: ', error);
              }
              return { data: null, error };
            });
        },
        update () {},
        delete () {}
      };

      setProviderData(currentData => {
        return {
          ...currentData,
          entries: {
            ...currentData.entries,
            [path]: newScope
          }
        };
      });
      // setProviderData({
      //   ...providerData,
      //   entries: {
      //     ...providerData.entries,
      //     [path]: newScope
      //   }
      // });

      if (options.autoLoad) {
        newScope.read();
      }

      return newScope;
    },
    setData (key, value) {
      setProviderData({
        ...providerData,
        data: {
          ...providerData.data,
          [key]: value
        }
      });
    }
    // TODO: add more methods/actions here
  };

  return (
    <ApiContext.Provider value={value}>
      {children}
    </ApiContext.Provider>
  );
}

// this allows you to use it as a simpler hook
function useApi (path, options = {}) {
  const context = useContext(ApiContext);
  if (context === undefined) {
    throw new Error('useApi must be used within a ApiProvider');
  }

  const scope = context.getScope(path, options);

  return scope;
}

export {
  ApiProvider,
  ApiContext,
  useApi
};
